module.exports = __webpack_public_path__ + "static/media/varify-badge-step1_2-mobile.22d3e44b.png";